import $axios from "@/common/http"  //导入封装的axios

export function queryPage(data:any){
    return $axios.get("/partner/queryPartnerRoomList",{params:data})
}
export function selectList(data:any){
    return $axios.get("/partner/selectList",{params:data})
}
// 
export function getProxy(data:any){
    return $axios.get("/partner/",{params:data})
}
// 获取合作伙伴
export function getpartners(data:any){
    return $axios.get("/partner/queryPartnerList",{params:data})
}

// 获取所有的省份
export function getProvince(data:any){
    return $axios.get("/province/selectList",{params:data})
}
//获取所有的市级
export function getCity(data:any){
    return $axios.get("/city/selectList",{params:data})
}
export function getPartnerQueryPage(data:any){
    return $axios.get("/partner/queryPage",{params:data})
}

// 获取表头，查询条件
export function queryPartnerHeaderInfo(data:any){
    return $axios.get("/partner/queryPartnerHeaderInfo",{params:data})
}